import { useEffect, useRef } from "react";
import { pushHistory } from "../lib/backStack";

// Syncs a view/tab state with browser history so the back button returns to the previous view.
export function useBackNav(key, value, setValue) {
  const fromPop = useRef(false);
  const first = useRef(true);
  const cur = useRef(value);
  cur.current = value;
  useEffect(() => {
    const onPop = (e) => {
      if (e.__backHandled) return;
      const v = e.state?.[key];
      if (v !== undefined && v !== cur.current) { fromPop.current = true; setValue(v); }
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [key, setValue]);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      window.history.replaceState({ ...(window.history.state || {}), [key]: value }, "");
      return;
    }
    if (fromPop.current) { fromPop.current = false; return; }
    if (window.history.state?.[key] !== value) pushHistory({ [key]: value });
  }, [key, value]);
}
